import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a 1.8 x 0.7 reception counter on 2x1 tiles: worktop at
// 0.75 on the receptionist side (-Z), a raised counter ledge at 1.1 and a
// warm-white front panel on the customer side (+Z).
const CARCASS = "#e8e4dc";
const FRONT = "#efece6";
const WORKTOP = "#d8d5cf";
const LEDGE = "#c8975a";
const PLINTH = "#2e2e30";

export const receptionDesk = defineModel({
  id: "reception-desk",
  batchId: "modern",
  name: "Reception desk",
  tags: ["modern", "interior", "furniture", "office", "counter", "reception"],
  summary: "A reception counter with a raised customer ledge and warm-white front.",
  tiles: { w: 2, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(1.7, 0.08, 0.5), color: PLINTH, position: [0, 0.04, -0.05] },
      // desk carcass under the worktop
      { geometry: new THREE.BoxGeometry(1.8, 0.62, 0.54), color: CARCASS, position: [0, 0.39, -0.05] },
      // worktop for the receptionist (top surface at 0.75, reaching back to -Z)
      { geometry: new THREE.BoxGeometry(1.8, 0.05, 0.58), color: WORKTOP, position: [0, 0.725, -0.06] },
      // warm-white front panel on the customer side (+Z), rising to the ledge
      { geometry: new THREE.BoxGeometry(1.8, 1.06, 0.08), color: FRONT, position: [0, 0.53, 0.31] },
      // raised counter ledge at 1.1 on the customer side
      { geometry: new THREE.BoxGeometry(1.8, 0.05, 0.28), color: LEDGE, position: [0, 1.075, 0.21] },
      // thin accent reveal line across the front panel
      { geometry: new THREE.BoxGeometry(1.8, 0.03, 0.02), color: PLINTH, position: [0, 0.72, 0.36] },
    ];
  },
  animations: [],
});
